<template>
  <div class="form-container" :class="{ 'dialog-mode': currentStep === 5 }">

    <div class="step-content" :class="{ 'dialog-step': currentStep === 5 }" v-if="currentStep !== 5&&currentStep !==6">
      <!-- 第0步：触摸进入页面 -->
<!--      <div v-if="currentStep === 1" class="step0-welcome" @click="enterForm">
        <div class="welcome-content">
          <h1 class="welcome-title">欢迎来到AI时尚助手</h1>
          <p class="welcome-subtitle">点击屏幕开始您的时尚之旅</p>
          <div class="welcome-tap-hint">
            <div class="tap-icon">👆</div>
            <span>触摸进入</span>
          </div>
        </div>
      </div>-->

<!--
      &lt;!&ndash; 第一步：个人信息表单 &ndash;&gt;
      <PersonalInfoStep1Content
        v-if="currentStep === 1"
        ref="step1Ref"
        :initialData="formData.step1"
        @next="handleStep1Next"
        @validation-change="handleStep1ValidationChange"
      />-->


      <!-- 第五步：对话 -->

    </div>
       <Dialog
               v-if="currentStep === 5"
               ref="dialogRef"
               :allFormData="formData"
               @restart="handleRestartFromDialog"
       />

  </div>
  <div v-if="currentStep!==5" class="steps-wrapper">
    <!-- 调试信息 -->
    <div v-if="false" style="position: fixed; top: 10px; left: 10px; background: red; color: white; padding: 10px; z-index: 9999;">
      Current Step: {{ currentStep }}
    </div>
    
    <Transition 
      :name="transitionName"
      @before-enter="onBeforeEnter"
      @enter="onEnter"
      @after-enter="onAfterEnter"
      @before-leave="onBeforeLeave"
      @leave="onLeave"
      @after-leave="onAfterLeave"
    >
      <!-- 第三步：图片上传 -->
      <div v-if="currentStep === 1" key="step1" class="step-wrapper">
        <PersonalInfoStep3Content
                ref="step3Ref"
                :step1Data="formData.step1"
                :step2Data="formData.step2"
                :initialData="formData.step3"
                @next="handleStep1Next"
                @validation-change="handleStep3ValidationChange"
                @data-change="handleStep3DataChange"
        />
      </div>

      <!-- 第二步：身体类型选择 -->
      <div v-else-if="currentStep === 2" key="step2" class="step-wrapper">
        <PersonalInfoStep2
                ref="step3Ref"
                :step1Data="formData.step1"
                :step2Data="formData.step2"
                :initialData="formData.step2"
                @next="handleStep2Next"
                @back="goBack"
                @validation-change="handleStep3ValidationChange"
                @data-change="handleStep2DataChange"
        />
      </div>

      <!-- 第二步：身体类型选择 -->
      <div v-else-if="currentStep === 3" key="step3" class="step-wrapper">
        <PersonalInfoStep2Content
                ref="step2Ref"
                :initialData="formData.step2"
                :allFormData="formData"
                @next="handleStep2ToNext"
                @back="goBack"
                @validation-change="handleStep2ValidationChange"
                @data-change="handleStep2DataChange"
        />
      </div>

      <!-- 第四步：品牌选择（移动端） -->
      <div v-else-if="currentStep === 4" key="step4" class="step-wrapper">
        <PersonalInfoStep4Mobile
                ref="step4Ref"
                :step1Data="formData.step1"
                :step2Data="formData.step2"
                :step3Data="formData.step3"
                :initialData="formData.step4"
                @next="handleStep4Next"
                @back="goBack"
                @validation-change="handleStep4ValidationChange"
                @data-change="handleStep4DataChange"
        />
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, nextTick } from 'vue'
import PersonalInfoStep1Content from './PersonalInfoStep1Content.vue'
import PersonalInfoStep2Content from './PersonalInfoStep2Content.vue'
import PersonalInfoStep2 from './PersonalInfoStep2.vue'
import PersonalInfoStep3Content from './PersonalInfoStep3Content.vue'
import PersonalInfoStep4Content from './PersonalInfoStep4Content.vue'
import PersonalInfoStep4Mobile from './PersonalInfoStep4Mobile.vue'
import Dialog from '../views/Dialog.vue'
// import StartExploreApi from "@/api/startExplore";
import { safeStorage } from '../utils/incognito'
import { expiredStorage } from '../utils/expiredStorage'
// import lastYIcon from '@/assets/images/svg/lastY.svg'
// import lastNIcon from '@/assets/images/svg/lastN.svg'

// 可以接收一些通用的配置参数
const props = defineProps({
  width: {
    type: String,
    default: '60%'
  }
})

// 当前步骤
const currentStep = ref(1)

// 过渡动画方向：'slide-left' 前进，'slide-right' 后退
const transitionName = ref('slide-left')

// 步骤配置
const steps = reactive([
  { name: '欢迎页面', component: 'WelcomePage' },
  { name: '个人信息', component: 'PersonalInfoStep1Content' },
  { name: '身体类型', component: 'PersonalInfoStep2Content' },
  { name: '图片上传', component: 'PersonalInfoStep3Content' },
  { name: '品牌选择', component: 'PersonalInfoStep4Content' },
  { name: '对话', component: 'Dialog' }
])

// 存储各步骤的数据
const formData = reactive({
  step1: {},
  step2: {},
  step3: {},
  step4: {}
})

// 进入表单（从欢迎页面到第一步）
const enterForm = () => {
  console.log('进入表单，跳转到第一步')
  currentStep.value = 1
}

// 保存滚动位置
let savedScrollY = 0

// 滚动阻止函数（必须定义为同一个引用才能正确移除）
const preventScrollHandler = (e) => {
  e.preventDefault()
  e.stopPropagation()
  return false
}

// 锁定滚动位置（在切换前立即执行）
const lockScroll = () => {
  // 保存当前滚动位置
  savedScrollY = window.scrollY || document.documentElement.scrollTop || 0

  // 立即锁定所有滚动
  document.documentElement.style.overflow = 'hidden'
  document.documentElement.style.position = 'fixed'
  document.documentElement.style.width = '100%'
  document.documentElement.style.top = `-${savedScrollY}px`

  document.body.style.overflow = 'hidden'
  document.body.style.position = 'fixed'
  document.body.style.width = '100%'
  document.body.style.top = `-${savedScrollY}px`

  // 重置所有滚动位置
  window.scrollTo(0, 0)
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0

  // 重置所有可能滚动的容器
  const scrollableElements = document.querySelectorAll('.main-content, .steps-wrapper, .step-wrapper, .personal-info-container')
  scrollableElements.forEach(el => {
    if (el) {
      el.scrollTop = 0
      el.style.overflow = 'hidden'
    }
  })

  // 添加滚动事件监听器（使用 capture 和 passive: false）
  window.addEventListener('scroll', preventScrollHandler, { passive: false, capture: true })
  window.addEventListener('wheel', preventScrollHandler, { passive: false, capture: true })
  window.addEventListener('touchmove', preventScrollHandler, { passive: false, capture: true })
  document.addEventListener('scroll', preventScrollHandler, { passive: false, capture: true })
}

// 解锁滚动位置
const unlockScroll = () => {
  // 移除滚动事件监听器（使用相同的函数引用）
  window.removeEventListener('scroll', preventScrollHandler, { capture: true })
  window.removeEventListener('wheel', preventScrollHandler, { capture: true })
  window.removeEventListener('touchmove', preventScrollHandler, { capture: true })
  document.removeEventListener('scroll', preventScrollHandler, { capture: true })

  // 恢复样式
  document.documentElement.style.overflow = ''
  document.documentElement.style.position = ''
  document.documentElement.style.width = ''
  document.documentElement.style.top = ''

  document.body.style.overflow = ''
  document.body.style.position = ''
  document.body.style.width = ''
  document.body.style.top = ''

  // 确保滚动位置在顶部
  window.scrollTo(0, 0)
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0

  // 恢复容器的滚动
  const scrollableElements = document.querySelectorAll('.main-content, .steps-wrapper, .step-wrapper, .personal-info-container')
  scrollableElements.forEach(el => {
    if (el) {
      el.style.overflow = ''
      el.scrollTop = 0
    }
  })
}

// 重置滚动位置（更激进的方法）
const resetScroll = () => {
  // 立即锁定
  lockScroll()

  // 使用多个时机确保滚动位置正确
  requestAnimationFrame(() => {
    lockScroll()
    setTimeout(() => {
      lockScroll()
    }, 50)
    setTimeout(() => {
      lockScroll()
      // 过渡结束后解锁
      setTimeout(() => {
        unlockScroll()
      }, 600) // 比过渡时间稍长
    }, 150)
  })
}

// 处理第一步的下一步
const handleStep1Next = (stepData) => {
  formData.step1 = stepData
  console.log('第一步数据:', stepData)
  transitionName.value = 'slide-left' // 前进动画
  // 在更新步骤前立即锁定滚动（关键！）
  lockScroll()
  currentStep.value = 2
  // DOM 更新后持续锁定滚动
  nextTick(() => {
    lockScroll()
    resetScroll()
    setTimeout(() => {
      lockScroll()
    }, 50)
    setTimeout(() => {
      lockScroll()
    }, 150)
    console.log('切换到步骤 2, currentStep:', currentStep.value)
  })
}

// 处理第二步的下一步（从 step2 跳转到 step3）
const handleStep2Next = (stepData) => {
  // 先保存 step2 数据
  formData.step2 = { ...formData.step2, ...stepData }
  console.log('第二步数据已保存:', formData.step2)
  console.log('完整表单数据:', formData)
  transitionName.value = 'slide-left' // 前进动画
  // 在更新步骤前立即锁定滚动（关键！）
  lockScroll()
  currentStep.value = 3
  // DOM 更新后持续锁定滚动
  nextTick(() => {
    lockScroll()
    resetScroll()
    setTimeout(() => {
      lockScroll()
    }, 50)
    setTimeout(() => {
      lockScroll()
    }, 150)
    console.log('切换到步骤 3, currentStep:', currentStep.value)
  })
}

// 处理第二步的下一步（从 step3 跳转到 step4）
const handleStep2ToNext = (stepData) => {
  // 保存 step2 数据到 formData.step2（这是从身高体重页面点击确定跳转）
  formData.step2 = { ...formData.step2, ...stepData }
  console.log('第二步数据（从step3点击确定）:', stepData)
  console.log('当前 formData.step2:', formData.step2)
  // 跳转到 step4（品牌选择）
  transitionName.value = 'slide-left' // 前进动画
  // 在更新步骤前立即锁定滚动（关键！）
  lockScroll()
  currentStep.value = 4
  // DOM 更新后持续锁定滚动
  nextTick(() => {
    lockScroll()
    resetScroll()
    setTimeout(() => {
      lockScroll()
    }, 50)
    setTimeout(() => {
      lockScroll()
    }, 150)
    console.log('切换到步骤 4, currentStep:', currentStep.value)
  })
}

// 返回上一步
const goBack = () => {
  if (currentStep.value > 1) {
    transitionName.value = 'slide-right' // 后退动画
    // 在更新步骤前立即锁定滚动（关键！）
    lockScroll()
    currentStep.value--
    // DOM 更新后持续锁定滚动
    nextTick(() => {
      lockScroll()
      resetScroll()
      setTimeout(() => {
        lockScroll()
      }, 50)
      setTimeout(() => {
        lockScroll()
      }, 150)
      console.log('返回上一步, currentStep:', currentStep.value)
    })
  }
}

// 处理第一步箭头点击
const handleStep1Arrow = () => {
  // 直接调用第一步的handleSubmit方法
  if (step1Ref.value && typeof step1Ref.value.handleSubmit === 'function') {
    step1Ref.value.handleSubmit()
  } else {
    console.warn('step1Ref.value.handleSubmit is not available')
  }
}

// 第一步组件引用
const step1Ref = ref(null)
const dialogRef = ref(null)

// 第一步表单验证状态
const step1FormValid = ref(false)

// 处理第一步验证状态变化

// 第二步组件引用和验证状态
const step2Ref = ref(null)
const step2FormValid = ref(false)

// 处理第二步验证状态变化
const handleStep2ValidationChange = (isValid) => {
  step2FormValid.value = isValid
}

// 处理第二步数据变化（实时保存身高、体重、身体类型）
const handleStep2DataChange = (stepData) => {
  console.log('=== FormContainer收到Step2数据变化 ===')
  console.log('接收到的stepData:', stepData)

  // 确保 formData.step2 存在且是对象
  if (!formData.step2 || typeof formData.step2 !== 'object') {
    formData.step2 = {}
  }

  // 合并数据，保留原有的所有字段
  formData.step2 = { ...formData.step2, ...stepData }

  console.log('第二步数据实时保存完成，当前formData.step2:', formData.step2)
  console.log('=== Step2数据变化处理结束 ===')
}

// 处理第二步箭头点击
const handleStep2Arrow = () => {
  if (step2Ref.value && typeof step2Ref.value.handleSubmit === 'function') {
    step2Ref.value.handleSubmit()
  } else {
    console.warn('step2Ref.value.handleSubmit is not available')
  }
}

// 第三步相关
const step3Ref = ref(null)
const step3FormValid = ref(false)

// 处理第三步的下一步
const handleStep3Next = (stepData) => {
  formData.step3 = stepData
  console.log('第三步数据:', stepData)

  // 如果有uploadResult，保存到formData中
  if (stepData.uploadResult) {
    formData.uploadResult = stepData.uploadResult
    console.log('API上传结果已保存:', stepData.uploadResult)
  }

  // 确保 step2 数据已经保存（可能用户在 step2 页面没有点击确定就跳转了）
  console.log('跳转到 step4，当前 formData.step2:', formData.step2)

  currentStep.value = 4
}



// 处理第三步验证状态变化
const handleStep3ValidationChange = (isValid) => {
  step3FormValid.value = isValid
}

// 处理第三步数据变化（实时保存图片数据）
const handleStep3DataChange = (stepData) => {
  console.log('=== FormContainer收到Step3数据变化 ===')
  console.log('接收到的stepData:', stepData)
  console.log('stepData.uploadResult:', stepData.uploadResult)

  formData.step3 = { ...formData.step3, ...stepData }

  // 如果有uploadResult，保存到formData中
  if (stepData.uploadResult) {
    formData.uploadResult = stepData.uploadResult
    console.log('第三步API上传结果实时保存:', stepData.uploadResult)
    console.log('当前formData.uploadResult:', formData.uploadResult)
  } else {
    console.log('stepData中没有uploadResult字段')
  }

  console.log('第三步数据实时保存完成，当前formData:', formData)
  console.log('=== Step3数据变化处理结束 ===')
}

// 处理第三步箭头点击
const handleStep3Arrow = () => {
  if (step3Ref.value && typeof step3Ref.value.handleSubmit === 'function') {
    step3Ref.value.handleSubmit()
  } else {
    console.warn('step3Ref.value.handleSubmit is not available')
  }
}

// 第四步相关
const step4Ref = ref(null)
const step4FormValid = ref(false)
const isGeneratingAvatar = ref(false) // 防止重复调用头像生成

// 处理第四步的下一步
const handleStep4Next = (stepData) => {
  formData.step4 = stepData
  console.log('第四步数据:', stepData)
  console.log('完整表单数据:', formData)
  transitionName.value = 'slide-left' // 前进动画
  // 在更新步骤前立即锁定滚动（关键！）
  lockScroll()
  currentStep.value = 5
  // DOM 更新后持续锁定滚动
  nextTick(() => {
    lockScroll()
    resetScroll()
    setTimeout(() => {
      lockScroll()
    }, 50)
    setTimeout(() => {
      lockScroll()
    }, 150)
    console.log('切换到步骤 5, currentStep:', currentStep.value)
  })
}

// 处理第四步验证状态变化
const handleStep4ValidationChange = (isValid) => {
  step4FormValid.value = isValid
}

// 处理第四步数据变化（实时保存品牌数据）
const handleStep4DataChange = (stepData) => {
  console.log('=== FormContainer收到Step4数据变化 ===')
  console.log('接收到的stepData:', stepData)

  // 确保 formData.step4 存在且是对象
  if (!formData.step4 || typeof formData.step4 !== 'object') {
    formData.step4 = {}
  }

  // 合并数据，保留原有的所有字段
  formData.step4 = { ...formData.step4, ...stepData }

  console.log('第四步数据实时保存完成，当前formData.step4:', formData.step4)
  console.log('=== Step4数据变化处理结束 ===')
}

const handleRestartFromDialog = () => {
  transitionName.value = 'slide-right'
  restart(1)
  nextTick(() => {
    resetScroll()
  })
}

// 锁定滚动的定时器引用
let lockScrollTimer = null

// Transition 钩子函数 - 在过渡前锁定滚动
const onBeforeEnter = () => {
  lockScroll()
}

// Transition 钩子函数 - 进入中持续锁定
const onEnter = () => {
  lockScroll()
  // 使用 requestAnimationFrame 持续锁定
  const lockScrollLoop = () => {
    lockScroll()
    if (lockScrollTimer) {
      lockScrollTimer = requestAnimationFrame(lockScrollLoop)
    }
  }
  lockScrollTimer = requestAnimationFrame(lockScrollLoop)
  // 500ms 后停止锁定循环
  setTimeout(() => {
    if (lockScrollTimer) {
      cancelAnimationFrame(lockScrollTimer)
      lockScrollTimer = null
    }
  }, 500)
}

// Transition 钩子函数 - 进入后解锁
const onAfterEnter = () => {
  if (lockScrollTimer) {
    cancelAnimationFrame(lockScrollTimer)
    lockScrollTimer = null
  }
  setTimeout(() => {
    unlockScroll()
  }, 100)
}

// Transition 钩子函数 - 离开前锁定
const onBeforeLeave = () => {
  lockScroll()
}

// Transition 钩子函数 - 离开中持续锁定
const onLeave = () => {
  lockScroll()
  // 使用 requestAnimationFrame 持续锁定
  const lockScrollLoop = () => {
    lockScroll()
    if (lockScrollTimer) {
      lockScrollTimer = requestAnimationFrame(lockScrollLoop)
    }
  }
  lockScrollTimer = requestAnimationFrame(lockScrollLoop)
  // 500ms 后停止锁定循环
  setTimeout(() => {
    if (lockScrollTimer) {
      cancelAnimationFrame(lockScrollTimer)
      lockScrollTimer = null
    }
  }, 500)
}

// Transition 钩子函数 - 离开后解锁
const onAfterLeave = () => {
  if (lockScrollTimer) {
    cancelAnimationFrame(lockScrollTimer)
    lockScrollTimer = null
  }
  setTimeout(() => {
    unlockScroll()
  }, 100)
}

// 重新开始 - 重置所有状态
const restart = (targetStep = 0) => {
  console.log('重新开始 - 重置所有状态')

  // 重置步骤到初始状态
  currentStep.value = targetStep

  // 清空所有表单数据
  formData.step1 = {}
  formData.step2 = {}
  formData.step3 = {}
  formData.step4 = {}
  if (formData.uploadResult) {
    delete formData.uploadResult
  }

  // 清除浏览器存储的数据
  try {
    expiredStorage.removeItem('agent-form-step4')
    expiredStorage.removeItem('agent-form-step44')
    expiredStorage.removeItem('user')
    console.log('已清除所有浏览器存储数据')
  } catch (error) {
    console.warn('清除浏览器存储失败:', error)
  }

  // 重置验证状态
  step1FormValid.value = false
  step2FormValid.value = false
  step3FormValid.value = false
  step4FormValid.value = false

  // 重置头像生成状态
  isGeneratingAvatar.value = false

  console.log('所有状态已重置，返回步骤', targetStep)
}

// 将 restart 方法暴露给父组件
defineExpose({
  restart
})

// 处理第四步提交（跳转到Dialog并持久化数据到浏览器）
onMounted(async () => {
  try {
    // 预加载下一步图标到缓存
    const preloadImages = [lastYIcon, lastNIcon]
    preloadImages.forEach((src) => {
      const img = new Image()
      img.src = src
    })

    // 检测是否为无痕模式
    const isIncognito = await import('@/utils/incognito').then(module => module.isIncognitoMode())
    if (isIncognito) {
      console.log('无痕模式检测到，清除已保存的数据并重新开始流程')
      // 清除所有相关数据
      safeStorage.removeItem('agent-form-step4')
      safeStorage.removeItem('agent-form-step1')
      safeStorage.removeItem('agent-form-step2')
      safeStorage.removeItem('agent-form-step3')
      // 重置到第一步
      currentStep.value = 0
      // 清空表单数据
      formData.value = {
        step1: {},
        step2: {},
        step3: {},
        step4: {}
      }
      // 显示提示信息
      alert('检测到无痕浏览器模式，已清除之前保存的数据，请重新填写表单。')
      return
    }

    const saved = expiredStorage.getItem('agent-form-step4')
    if (saved) {
      const remainingTime = expiredStorage.getRemainingTime('agent-form-step4')
      console.log(`从过期存储恢复数据，剩余时间: ${remainingTime} 分钟`)
      currentStep.value = 5
    } else {
      console.log('未找到有效的Step4数据或数据已过期')
    }
  } catch (e) {
    console.warn('数据读取失败:', e)
  }
})
</script>

<style scoped>
/* 通用表单容器样式 */
.form-container {
  /*background-color: rgba(51, 51, 51, 0.6);*/
  /*backdrop-filter: blur(15px);*/
  /*border: 1px solid rgba(255, 255, 255, 0.1);*/
  border-radius: 24px;
  /*min-height: 550px; !* 增加高度以适应更底部的输入框 *!
  height: 550px; !* 固定高度，防止内容变化时高度改变 *!*/
  padding: 40px 50px 0px; /* 增加底部padding为输入框留出充足空间 */
  /*width: v-bind(width);*/
  /*max-width: 960px;*/
  /*min-width: 320px;*/
  text-align: center;
  /*box-shadow: 0 4px 30px rgba(0, 0, 0, 0.2);*/
  /*margin: 0 auto;*/
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: visible; /* 允许子元素超出容器边界显示 */
  width: 100%;
}

/* 对话模式下移除内边距以让子元素铺满宽度 */
.form-container.dialog-mode {
  padding: 0;
  text-align: left;
}

/* 步骤指示器 */
.step-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
  padding: 0 20px;
}

.step-dot {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
  border: 2px solid rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.7);
}

.step-dot.active {
  background: rgba(76, 175, 80, 0.9);
  border-color: rgba(76, 175, 80, 1);
  color: white;
  box-shadow: 0 0 0 4px rgba(76, 175, 80, 0.2);
}

.step-dot.completed {
  background: rgba(76, 175, 80, 0.8);
  border-color: rgba(76, 175, 80, 1);
  color: white;
}

/* 第0步：欢迎页面样式 */
.step0-welcome {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.step0-welcome:hover {
  transform: scale(1.02);
}

.welcome-content {
  text-align: center;
  padding: 40px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.welcome-content:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.2);
}

.welcome-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.95);
  margin-bottom: 20px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.welcome-subtitle {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 30px;
  line-height: 1.6;
}

.welcome-tap-hint {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 1rem;
  animation: pulse 2s infinite;
}

.tap-icon {
  font-size: 2rem;
  animation: bounce 1.5s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.7;
  }
  50% {
    opacity: 1;
  }
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

/* 步骤内容区域 */
.step-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 400px;
}

/* Dialog步骤的特殊样式 */
.step-content.dialog-step {
  min-height: 500px;
}

/* 返回按钮 */
.back-button {
  position: absolute;
  top: 20px;
  left: 20px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  padding: 8px 12px;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  backdrop-filter: blur(10px);
}

.back-button:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.3);
  color: rgba(255, 255, 255, 1);
}

.back-icon {
  width: 16px;
  height: 16px;
}

/* 第一步箭头按钮 */
.step1-arrow-button {
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  background: rgba(76, 175, 80, 0.8);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  z-index: 10;
}

.step1-arrow-button:hover {
  background: rgba(76, 175, 80, 1);
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

.step1-arrow-button:active:not(.disabled) {
  transform: translateY(-50%) scale(0.95);
}

.step1-arrow-button.disabled {
  opacity: 0.4;
  cursor: not-allowed;
  background: rgba(100, 100, 100, 0.3);
}

.step1-arrow-button.disabled:hover {
  transform: translateY(-50%);
  background: rgba(100, 100, 100, 0.3);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.step1-arrow-button .arrow-icon {
  width: 20px;
  height: 20px;
  color: white;
}

/* 第一步箭头图标（无按钮版） */
.step1-arrow-img {
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  cursor: pointer;
  transition: transform 0.3s ease, opacity 0.3s ease;
  z-index: 10;
}

.step1-arrow-img:not(.disabled):hover {
  transform: translateY(-50%) scale(1.1);
}

.step1-arrow-img.disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* 第二步左箭头按钮 */
.step2-left-arrow-button {
  position: absolute;
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  background: rgba(76, 175, 80, 0.8);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  z-index: 10;
}

.step2-left-arrow-button:hover {
  background: rgba(76, 175, 80, 1);
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

.step2-left-arrow-button:active {
  transform: translateY(-50%) scale(0.95);
}

/* 第二步右箭头按钮 */
.step2-right-arrow-button {
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  background: rgba(76, 175, 80, 0.8);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  z-index: 10;
}

.step2-right-arrow-button:hover:not(.disabled) {
  background: rgba(76, 175, 80, 1);
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

.step2-right-arrow-button:active:not(.disabled) {
  transform: translateY(-50%) scale(0.95);
}

.step2-right-arrow-button.disabled {
  opacity: 0.4;
  cursor: not-allowed;
  background: rgba(100, 100, 100, 0.3);
}

.step2-right-arrow-button.disabled:hover {
  transform: translateY(-50%);
  background: rgba(100, 100, 100, 0.3);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.step2-left-arrow-button .arrow-icon,
.step2-right-arrow-button .arrow-icon {
  width: 20px;
  height: 20px;
  color: white;
}

/* 第二步箭头图标（无按钮版） */
.step2-left-arrow-img,
.step2-right-arrow-img {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  cursor: pointer;
  transition: transform 0.3s ease, opacity 0.3s ease;
  z-index: 10;
}
.step2-left-arrow-img { left: 20px; }
.step2-right-arrow-img { right: 20px; }
.step2-right-arrow-img:not(.disabled):hover,
.step2-left-arrow-img:not(.disabled):hover { transform: translateY(-50%) scale(1.1); }
.step2-right-arrow-img.disabled { opacity: 0.4; cursor: not-allowed; }

/* 第三步左箭头按钮 */
.step3-left-arrow-button {
  position: absolute;
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  background: rgba(76, 175, 80, 0.8);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  z-index: 10;
}

.step3-left-arrow-button:hover {
  background: rgba(76, 175, 80, 1);
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

.step3-left-arrow-button:active {
  transform: translateY(-50%) scale(0.95);
}

/* 第三步右箭头按钮 */
.step3-right-arrow-button {
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  background: rgba(76, 175, 80, 0.8);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  z-index: 10;
}

.step3-right-arrow-button:hover:not(.disabled) {
  background: rgba(76, 175, 80, 1);
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

.step3-right-arrow-button:active:not(.disabled) {
  transform: translateY(-50%) scale(0.95);
}

.step3-right-arrow-button.disabled {
  opacity: 0.4;
  cursor: not-allowed;
  background: rgba(100, 100, 100, 0.3);
}

.step3-right-arrow-button.disabled:hover {
  transform: translateY(-50%);
  background: rgba(100, 100, 100, 0.3);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.step3-left-arrow-button .arrow-icon,
.step3-right-arrow-button .arrow-icon {
  width: 20px;
  height: 20px;
  color: white;
}

/* 第三步箭头图标（无按钮版） */
.step3-left-arrow-img,
.step3-right-arrow-img {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  cursor: pointer;
  transition: transform 0.3s ease, opacity 0.3s ease;
  z-index: 10;
}
.step3-left-arrow-img { left: 20px; }
.step3-right-arrow-img { right: 20px; }
.step3-right-arrow-img:not(.disabled):hover,
.step3-left-arrow-img:not(.disabled):hover { transform: translateY(-50%) scale(1.1); }
.step3-right-arrow-img.disabled { opacity: 0.4; cursor: not-allowed; }

/* 第四步左箭头按钮 */
.step4-left-arrow-button {
  position: absolute;
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  background: rgba(76, 175, 80, 0.8);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  z-index: 10;
}

.step4-left-arrow-button:hover {
  background: rgba(76, 175, 80, 1);
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

.step4-left-arrow-button:active {
  transform: translateY(-50%) scale(0.95);
}

.step4-left-arrow-button .arrow-icon {
  width: 20px;
  height: 20px;
  color: white;
}

/* 第四步箭头图标（无按钮版） */
.step4-left-arrow-img {
  position: absolute;
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  cursor: pointer;
  transition: transform 0.3s ease;
  z-index: 10;
}
.step4-left-arrow-img:hover { transform: translateY(-50%) scale(1.1); }

/* 第五步（Dialog）左箭头按钮 */
.step5-left-arrow-button {
  position: absolute;
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  background: rgba(76, 175, 80, 0.8);
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  z-index: 10;
}

.step5-left-arrow-button:hover {
  background: rgba(76, 175, 80, 1);
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

.step5-left-arrow-button:active {
  transform: translateY(-50%) scale(0.95);
}

.step5-left-arrow-button .arrow-icon {
  width: 20px;
  height: 20px;
  color: white;
}

/* 步骤容器包装器 */
.steps-wrapper {
  position: absolute;
  top: 0;
  left: 0 !important;
  right: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  /* 防止在过渡期间滚动 */
  overscroll-behavior: none;
  /* 防止触摸滚动 */
  touch-action: none;
  /* 隔离布局，防止影响外部滚动 */
  contain: layout style paint;
  /* 确保覆盖在 form-container 上方 */
  z-index: 10;
  box-sizing: border-box;
}

/* 确保步骤组件在过渡时正确显示 */
.steps-wrapper > * {
  width: 100%;
}

/* 步骤包装器 - 确保 Transition 有单个根元素，并在过渡期间叠加显示 */
.step-wrapper {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  min-height: 100vh;
  /* 防止在过渡期间滚动 */
  overscroll-behavior: none;
  /* 防止触摸滚动 */
  touch-action: none;
}

/* 过渡期间禁用滚动 - 全局锁定 */
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  pointer-events: none;
  /* 防止过渡期间滚动 */
  overflow: hidden !important;
  /* 隔离布局 */
}


.slide-left-enter-active .step-wrapper,
.slide-left-leave-active .step-wrapper,
.slide-right-enter-active .step-wrapper,
.slide-right-leave-active .step-wrapper {
  overflow: hidden !important;
  /* 确保过渡期间不会触发滚动 */
  max-height: 100vh !important;
  /* 防止滚动 */
}

/* 从右往左滑动过渡动画（前进）- 两个页面同时滑动 */
.slide-left-enter-active,
.slide-left-leave-active {
  transition: opacity 0.8s cubic-bezier(0.25, 0.8, 0.25, 1), transform 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
  z-index: 1;
  will-change: transform, opacity;
}

.slide-left-enter-active {
  z-index: 2;
}

.slide-left-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.slide-left-enter-to {
  opacity: 1;
  transform: translateX(0);
}

.slide-left-leave-from {
  opacity: 1;
  transform: translateX(0);
}

.slide-left-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}

/* 从左往右滑动过渡动画（后退）- 两个页面同时滑动 */
.slide-right-enter-active,
.slide-right-leave-active {
  transition: opacity 0.8s cubic-bezier(0.25, 0.8, 0.25, 1), transform 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
  z-index: 1;
  will-change: transform, opacity;
}

.slide-right-enter-active {
  z-index: 2;
}

.slide-right-enter-from {
  opacity: 0;
  transform: translateX(-100%);
}

.slide-right-enter-to {
  opacity: 1;
  transform: translateX(0);
}

.slide-right-leave-from {
  opacity: 1;
  transform: translateX(0);
}

.slide-right-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

/* 确保 fixed 定位的组件在过渡时正确显示 */
.slide-left-enter-active .personal-info-container,
.slide-left-leave-active .personal-info-container,
.slide-right-enter-active .personal-info-container,
.slide-right-leave-active .personal-info-container {
  will-change: transform;
}

</style>
